import styled from "styled-components";

export const StyledWrapper = styled.div`
  padding: 16px;
  width: 33%;
  height: 100px;
  color: ${({ theme }) => theme.colors.neutralsWhite};
  background-color: ${({ theme }) => theme.colors.neutralsText};
  border-radius: 4px;
  container-type: inline-size;

  .callout-icon {
    float: right;
  }

  .callout-label {
    padding-top: 8px;
    color: ${({ theme }) => theme.colors.neutralsWhite};
    ${({ theme }) => theme.fontStyles.InterfaceCopyBold}

    ${({ theme }) => theme.media.onlyDesktop`
      padding-left: 12px;
    `};

    @container (width > 200px) {
      padding-left: 12px;
    }
  }

  .callout-value {
    padding-top: 6px;
    color: ${({ theme }) => theme.colors.neutralsWhite};
    ${({ theme }) => theme.fontStyles.MobileHeadlinesH3}

    ${({ theme }) => theme.media.onlyDesktop`
      padding: 6px 12px 0;
      ${({ theme }) => theme.fontStyles.MobileHeadlinesH2}
    `};

    @container (width > 200px) {
      padding: 6px 12px 0;
      ${({ theme }) => theme.fontStyles.MobileHeadlinesH2}
    }
  }
`;
